<template>
  <div class="fixed top-0 right-0 bottom-0 left-0 grid grid-cols-12 grid-rows-6 h-full w-full">
    <div class="relative col-start-1 col-span-12 row-start-1 row-span-6 z-0">
      <div class="absolute top-0 right-0 bottom-0 left-0 bg-gray-500/75"></div>
      <div id="AuthBackground"></div>
    </div>
    <div class="lg:col-start-1 lg:col-span-7 lg:row-start-1 lg:row-span-6 hidden lg:flex flex-col justify-center items-center z-10">
      <h1 class="mb-2 sm:text-1xl lg:text-3xl xl:text-5xl font-bold text-white">SALMON TRACK</h1>
      <h2 class="sm:text-sm lg:text-lg xl:text-2xl font-bold text-gray-200 text-center">SISTEM INFORMASI<br/>PEMANTAUAN KAPAL PERIKANAN</h2>
    </div>
    <div class="col-start-1 col-span-12 row-start-1 row-span-6 lg:col-start-8 lg:col-span-5 z-10 flex flex-col justify-center items-center">
      <form
        @submit.prevent="submitLogin()"
        class="relative w-11/12 sm:w-1/2 lg:w-3/4 px-5 py-5 bg-gray-500/25 rounded-md">
        <div class="flex justify-center items-center mb-3">
          <img
            class="w-32 h-32"
            src="../assets/images/kkp-white.png" />
        </div>
        <Message :message="message" />
        <div class="w-full mb-3">
          <label class="text-sm text-white">Username</label>
          <input
            v-model="username"
            class="form-input w-full h-full rounded-md text-sm text-gray-500"
            type="text">
        </div>
        <div class="w-full mb-3">
          <label class="text-sm text-white">Password</label>
          <input
            v-model="password"
            class="form-input w-full h-full rounded-md text-sm text-gray-500"
            type="password"
            autocomplete="disable">
        </div>
        <div class="w-full mb-3">
          <router-link
            to="/salmontrack/recorvery"
            @click="unsetMessage()"
            class="text-sm text-gray-100">Lupa Password ?</router-link>
        </div>
        <div class="flex justify-end items-center w-full">
          <button
            class="px-1 py-1 w-32 h-8 bg-gray-500 text-white text-sm rounded-md"
            type="submit">Login</button>
        </div>
        <Loading :message="loading" />
      </form>
      <div class="px-5 py-5 flex justify-center align-center w-full">
        <p class="text-sm text-white">&copy; 2022 SALMONTRACK</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Message from './Message.vue'
import Loading from './Loading.vue'

export default {
  name: 'Login',
  components: {
    Message,
    Loading
  },
  data: () => ({
    username: null,
    password: null,
    previousPath: '/salmontrack/dashboard'
  }),
  computed: {
    ...mapGetters([
      'message',
      'loading',
      'activeMenu'
    ])
  },
  methods: {
    ...mapActions([
      'toLogin',
      'toLoadPoi',
      'toActiveMenu'
    ]),
    ...mapMutations(['unsetMessage']),
    submitLogin: async function () {
      const loginResult = await this.toLogin({
        username: this.username,
        password: this.password
      })

      if (loginResult && !(loginResult instanceof Error)) {
        if (loginResult.status === 200) {
          // this.$router.push({ path: this.previousPath })

          await this.toLoadPoi()

          // hide current menu
          this.toActiveMenu({
            name: this.activeMenu
          })

          // redirect to main page
          this.$router.push({ path: '/salmontrack' })
        }
      }
    }
  },
  beforeRouteEnter: function (to, from, next) {
    next(vm => {
      vm.previousPath = from.path
    })
  }
}
</script>

<style scoped>
#AuthBackground {
  background-image: url("../assets/images/login-banner.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
}
</style>
